module.exports = __webpack_public_path__ + "static/media/fulham.b154ccbd.png";